import React, { useState } from 'react';
import { useSelector } from 'react-redux';

// Components
import { Alert, Form, Modal, Select } from 'antd';

// Selectors
import { getDeviceTypesList } from '../../../data/deviceTypes/selectors';

// Others
import { mergeDevices } from '../../../data/devices/service';
import { strings } from '../../../localization';
import { MODAL_SIZES } from '../../../constants/modal';

const MergeDeviceModal = (props) => {
    const deviceTypesList = useSelector(getDeviceTypesList);
    const [errorMessage, setErrorMessage] = useState('');

    const {
        form,
        isShown,
        hideModal,
        recordToEdit,
        meter,
        reloadPage,
    } = props;

    const getId = object => (object && (object.device || object.id));
    const deviceId = getId(recordToEdit);
    // otherDevices should never be empty since we can only access this component if the array has a length >1
    const otherDevices = meter && meter.devices.data.filter(d => getId(d) !== deviceId) || [];

    const createItem = device => (
        <Select.Option
            value={getId(device)}
            key={`key${getId(device)}`}>
            {device.name}
        </Select.Option>
    );

    const handleSubmit = () => {
        setErrorMessage(null);
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            mergeDevices(deviceId, values.targetDevice)
                .then(() => {
                    setErrorMessage('');
                    reloadPage();
                    hideModal();
                })
                .catch(err => {
                    console.log({ err });
                    if (err.response) {
                        if (err.response.text) {
                            setErrorMessage(err.response.text);
                        } else {
                            setErrorMessage(err.response);
                        }
                    } else {
                        setErrorMessage(err);
                    }
                });
        });
    };

    if (!deviceTypesList) return null;
    const { getFieldDecorator } = form;
    return (
        <Modal
            key='merge-device'
            visible={isShown}
            width={MODAL_SIZES.MEDIUM}
            title={strings.homes.detail.mergeModalTitle1 + (recordToEdit?recordToEdit.name:'') + strings.homes.detail.mergeModalTitle2}
            onCancel={hideModal}
            onOk={handleSubmit}
            cancelText={strings.cancel}
            okText={strings.homes.detail.mergeModalOk}
        >
            {errorMessage &&
                <Alert
                    message={errorMessage}
                    type='error'
                    style={{ marginBottom: 30 }}
                    showIcon
                />
            }
            <Form>
                {
                    getFieldDecorator('targetDevice', {
                        initialValue: getId(otherDevices[0]),
                        rules: [{ required: true, message: strings.requiredField }],
                    })(
                        <Select>
                            {
                                otherDevices.map(device => (
                                    createItem(device)
                                ))}
                        </Select>,
                    )}
            </Form>
        </Modal>
    );
};

export default Form.create()(MergeDeviceModal);
